import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useForm } from "../../hooks/useForm";
import { UrlWs } from "../../utils/Global";
import { Direcciones } from "../Otros/Direcciones";
import { PlaceholderColumnas } from "../Otros/Placeholder";
import { Precalificadores } from "../Otros/Precalificadores";

async function actualizarPrecalificador(payload) {
  const url = UrlWs+"/prequalifiers";
  const opciones = await fetch(url, {
    method: "PUT",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      if (response.status == 400) {
        return [];
      } else {
        return response.json();
      }
    })
    .then((datos) => {
      return datos;
    });
  return opciones;
}
async function cargarUnidades(idDireccion) {
  const url = UrlWs+"/unity-management/" + idDireccion + "/unitsByDirection";
  const opciones = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(async (response) => {
      if (response.status == 400) {
        return [];
      } 
      // Verificamos si hay contenido antes de intentar parsearlo
      const text = await response.text();
      if (!text) {
        return [];
      }

      return JSON.parse(text);
    })
    .then((datos) => {
      return datos;
    });
  return opciones;
}

async function cargarPrecalificadoresActuales(direccion, idProcess) {
  const url =UrlWs+
    "/prequalifiers/" +
    direccion +
    "/process/" +
    idProcess;
  const opciones = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      if (response.status == 400) {
        return [];
      } else {
        return response.json();
      }
    })
    .then((datos) => {
      return datos;
    });
  return opciones;
}

const SelectDirecciones = ({
  updateValue,
  handleChange,
  nuevoValue = null,
  disabled = null,
}) => {
  return (
    <Direcciones
      updateValue={updateValue}
      handleChange={handleChange}
      nuevoValue={nuevoValue}
      disabled={disabled}
    />
  );
};

const SelectPrecalificadores = ({
  nombreCampo,
  updateValue,
  nuevoValue = null,
  campoIndex = null,
}) => {
  return (
    <Precalificadores
      nombreCampo={nombreCampo}
      updateValue={updateValue}
      nuevoValue={nuevoValue}
      campoIndex={campoIndex}
    />
  );
};

export const ActualizarPrecalificadores = ({ idProcess }) => {
  const [valoresForm, handleInputChange, reset, updateValue, updateState] =
    useForm({
      direccion: null,
      direccion_prequalifier_id: null,
      direccion_officer_id: null,
      unidades_officer_id: [],
    });
  const {
    direccion,
    direccion_prequalifier_id,
    direccion_officer_id,
    unidades_officer_id,
  } = valoresForm;
  const [unidades, setUnidades] = useState(null);
  const [precalificadores, setPrecalificadores] = useState(null);
  const [cargandoDatos, setCargandoDatos] = useState(false);
  const [enviandoDatos, setEnviandoDatos] = useState(false);

  useEffect(() => {
    console.log("Efefect direccion: " + direccion);
    if (direccion != null) {
      setCargandoDatos(true);
      cargarUnidades(direccion)
        .then((datos) => {
          console.log("THE DATA ->",datos);
          setUnidades(datos);
        })
        .then(() => {
          cargarPrecalificadoresActuales(direccion, idProcess).then((datos) => {
            setPrecalificadores(datos);
            setCargandoDatos(false);
          });
        });
    }
  }, [direccion]);
  console.log("Direccion...: " + direccion);
  const handleClick = async () => {
    //Actualizar direccion
    setEnviandoDatos(true);
    await actualizarPrecalificador({
      id_prequalifiers: direccion_prequalifier_id,
      id_officer: direccion_officer_id,
    });

    //Actualizar precalificadores de las unidades
    precalificadores.forEach(async (precalificador) => {
      if (
        precalificador.id_municipalUnit != null &&
        unidades_officer_id[precalificador.id_municipalUnit] != null
      ) {
        await actualizarPrecalificador({
          id_prequalifiers: precalificador.id_prequalifiers,
          id_officer: unidades_officer_id[precalificador.id_municipalUnit],
        });
      }
      const respuesta = true;
      if (respuesta === true) {
        //Continuar
      } else {
        //Error
        Swal.fire({
          title: "Error",
          text: "Ocurrió un error, por favor vuelva a intentarlo",
          icon: "success",
          confirmButtonText: "Ok",
        });
        return false;
      }
    });

    Swal.fire({
      title: "Listo",
      text: "Precalificadores actualizados",
      icon: "success",
      confirmButtonText: "Ok",
    });
    setEnviandoDatos(false);
    //Actualizar unidades
  };

  let precalificadorDireccion = null;
  if (direccion != null && precalificadores != null) {
    const encontrado = precalificadores.find((p) => p.id_municipalUnit == null);
    if (typeof encontrado != "undefined") {
      precalificadorDireccion = encontrado.id_officer;
      if (direccion_prequalifier_id != encontrado.id_prequalifiers) {
        updateValue("direccion_prequalifier_id", encontrado.id_prequalifiers);
      }
    }
  }
  return (
    <>
      <div className="modal fade" id="m-acPrecalificadores" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered mw-900px ">
          <div className="modal-content">
            <div className="modal-header ">
              <h2> Actualizar Precalificadores del sistema</h2>
              <div
                className="btn btn-sm btn-icon btn-active-color-primary "
                data-bs-dismiss="modal"
              >
                <span className="svg-icon svg-icon-1 ">X</span>
              </div>
            </div>
            <div className="modal-body py-lg-10 px-lg-10">
              <div className="row">
                <div className="col-8">
                  <div className="mb-10">
                    <label htmlFor=" " className="form-label">
                      Seleccione Dirección:
                    </label>
                    <SelectDirecciones
                      updateValue={() => {}}
                      disabled={cargandoDatos}
                      handleChange={(direccion) => {
                        updateState([
                          {
                            name: "direccion",
                            value: direccion,
                          },
                          {
                            name: "unidades_officer_id",
                            value: [],
                          },
                        ]);
                      }}
                    ></SelectDirecciones>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <span className="fw-bolder fs-5 mb-4 d-inline-block">
                      información asignada
                    </span>
                    <div className="mb-10">
                      <label className="form-label">Dirección</label>
                      <SelectDirecciones
                        updateValue={() => {}}
                        disabled={true}
                        nuevoValue={direccion}
                      ></SelectDirecciones>
                    </div>
                  </div>

                  <div className="col-6">
                    <span className="fw-bolder fs-5 mb-4 d-inline-block">
                       Asignar precalificador
                    </span>
                    <div className="mb-10">
                      <label className="form-label">Precalificador</label>
                      <SelectPrecalificadores
                        nombreCampo="direccion_officer_id"
                        updateValue={updateValue}
                        nuevoValue={precalificadorDireccion}
                      ></SelectPrecalificadores>
                    </div>
                  </div>
                </div>

                {cargandoDatos ? (
                  <PlaceholderColumnas
                    columnas={2}
                    filas={3}
                    keys="unidad"
                  ></PlaceholderColumnas>
                ) : unidades != null ? (
                  unidades.map((u) => {
                    let precalificadorActual = precalificadores.find(
                      (p) => p.id_municipalUnit == u.id_Umunicipal
                    );

                    let idPrecalificadorActual;
                    if (typeof precalificadorActual == "undefined") {
                      precalificadorActual = null;
                    } else {
                      precalificadorActual = precalificadorActual.id_officer;
                      idPrecalificadorActual =
                        precalificadorActual.id_prequalifiers;
                    }

                    return (
                      <div className="row" key={`div${u.id_Umunicipal}`}>
                        <div className="col-6">
                          <div className="mb-10">
                            <label htmlFor=" " className="form-label">
                              Unidad
                            </label>
                            <input
                              type="text"
                              className="form-control mb-5"
                              placeholder={u.nameUmunicipal}
                              disabled
                            />
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="mb-10">
                            <label htmlFor=" " className="form-label">
                              Precalificador
                            </label>
                            <SelectPrecalificadores
                              key={`unidad-${u.id_Umunicipal}`}
                              nombreCampo="unidades_officer_id"
                              campoIndex={u.id_Umunicipal}
                              updateValue={updateValue}
                              nuevoValue={precalificadorActual}
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <>
                    <h2>Dirección sin unidades</h2>
                  </>
                )}
              </div>

              <div className="d-flex justify-content-end">
                {cargandoDatos ? (
                  <></>
                ) : (
                  <button
                    type="button"
                    className="btn btn-sm btn-success"
                    onClick={handleClick}
                    disabled={enviandoDatos}
                  >
                    {enviandoDatos
                      ? " Actualizando..."
                      : " Actualizar"}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
